import { useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { ImportPreviewTableRow } from 'entities/ui/model/absence';

/**
@hook получение дубликата 
*/
export const useDuplicateErrorRow = (id: number): ImportPreviewTableRow | undefined => {
  const duplicateErrors = useAppSelector(uiModel.Absence.selectors.getDuplicateErrors);
  const personnelNumber = duplicateErrors.find(item => id === item.tableId)?.personnelNumber;
  const duplicates = duplicateErrors.filter(item => personnelNumber === item.personnelNumber);

  if (duplicates.length === 2) {
    return duplicates.find(item => id !== item.tableId);
  }
};
